// Third party
import React from 'react';

// Components
import { withErrorBoundary } from '../errors';

// Utils
import AdvancedSearchInput from './AdvancedSearchInput';
import { formatMessage } from '../../../utils/i18n';
import SearchOptions from '@/types/search-options';
import Fund from '@/types/fund';

type Props = {
  clearPreLoadQuery: (query: string) => void;
  hasData?: boolean;
  loadingFilters?: boolean;
  preLoadQuery?: string;
  minimizedFiltersToShow?: number;
  onProxySearch: (options: SearchOptions) => Promise<Fund[]>;
  loadingResults?: boolean;
};

const ProxySearchInput = (props: Props) => {
  const { loadingFilters, preLoadQuery, minimizedFiltersToShow, loadingResults, hasData } = props;
  const loadingProps = { loadingFilters, loadingResults };

  return (
    <AdvancedSearchInput
      {...loadingProps}
      className="proxy-search-input"
      placeholder="Search.Proxies.Placeholder"
      buttonLabel="Search.Proxies.Apply"
      onSearch={props.onProxySearch}
      clearPreLoadQuery={props.clearPreLoadQuery}
      preLoadQuery={preLoadQuery}
      placeholderText={formatMessage('Search.Proxies.Placeholder')}
      applySearchText={formatMessage(`Search.${loadingResults ? 'Searching' : 'Proxies.Apply'}`)}
      minimizedFiltersToShow={minimizedFiltersToShow}
      hasData={hasData}
    />
  );
};

export default withErrorBoundary(ProxySearchInput);
